<template>
  <div class="footer">
    <b-container class="bv-example-row">
      <h1>fale com a gente</h1>
      <b-row align-h="start">
        <b-col md="4" sm="12" class="coluna1">
          <h3>Niara</h3>
          <p class="niaraFrase">Empoderar para não silenciar!</p>
          <a
            href="https://www.instagram.com/niaraufla"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p class="niaraInsta">
              <img
                v-if="imgInsta1Preta"
                @mouseover="alteraImg('insta1')"
                :src="require('@/assets/insta.png')"
                alt="imagem do instagram"
              />
              <img
                v-else
                @mouseout="alteraImg('insta1')"
                :src="require('@/assets/instaRosa.png')"
                alt="imagem do instagram"
              />
              @niaraufla
            </p>
          </a>
          <a href="mailto:niara@ufla.br?" target="_blank">
            <p class="niaraEmail">
              <img
                v-if="imgEmailPreta"
                @mouseover="alteraImg('email')"
                :src="require('@/assets/email.png')"
                alt="imagem do email"
                class="lk"
              />
              <img
                v-else
                @mouseout="alteraImg('email')"
                :src="require('@/assets/emailRosa.png')"
                alt="imagem do email"
                class="lk"
              />
              niara@ufla.br
            </p>
          </a>
        </b-col>
      </b-row>
    </b-container>
    <p class="desenvolvido">
      Desenvolvido com <b-icon icon="heart-fill" class="coracao"></b-icon> por Comp Júnior
    </p>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-family: 'Yeseva One', cursive;
  padding-top: 3rem;
  padding-bottom: 2rem;
  font-size: 3rem;
  color: #363636;
}
h3 {
  font-family: 'Montserrat', sans-serif;
  color: #363636;
  font-weight: bold;
  margin-bottom: 1.5rem;
  padding-top: 1rem;
}
p {
  font-family: 'Montserrat', sans-serif;
  color: #363636;
  font-size: 1.3rem;
  padding-top: 0.5rem;
  margin-bottom: 0;
}
img {
  width: 10%;
  margin-right: 1rem;
}
a:hover {
  text-decoration: none;
}
.footer {
  background-color: #e2cab2;
}
.coluna1 {
  margin-right: 4rem;
}
.lk {
  width: 9%;
  margin-right: 1.2rem;
  margin-left: 0.1rem;
}
.bv-example-row {
  padding-bottom: 2rem;
}
.desenvolvido {
  text-align: center;
  padding-bottom: 0.3rem;
  font-size: 1rem;
}
.coracao {
  color: rgb(204 0 0);
}
.email {
  margin-left: 3.5rem;
}
.niaraFrase {
  margin-top: 1.65rem;
}
.niaraInsta {
  margin-top: 3.5rem !important;
}
.niaraEmail {
  margin-top: 1.5rem;
}
@media (max-width: 1024px) {
  .niaraInsta {
    margin-top: 1.7rem !important;
  }
}
@media (max-width: 767px) {
  .coluna1 {
    margin-right: 0rem;
  }
  .bv-example-row {
    padding-left: 2rem;
  }
}
@media (max-width: 280px) {
  img {
    margin-right: 0.8rem;
  }
  p {
    font-size: 1rem;
  }
  .email {
    margin-left: 2.7rem;
  }
}
@media (max-width: 768px) and (min-width: 768px) {
  p {
    font-size: 1rem;
  }
  .email {
    margin-left: 2.7rem;
  }
}
@media (max-width: 540px) and (min-width: 540px) {
  .email {
    margin-left: 4.4rem;
  }
}
</style>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      imgInsta1Preta: true,
      imgEmailPreta: true,
    };
  },
  methods: {
    alteraImg(imagem) {
      if (imagem == 'insta1') {
        this.imgInsta1Preta = !this.imgInsta1Preta;
      } else if (imagem == 'email') {
        this.imgEmailPreta = !this.imgEmailPreta;
      }
    },
  },
};
</script>